'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(props) {
  return _react2.default.createElement(
    'footer',
    null,
    _react2.default.createElement(
      'div',
      { className: 'container-fluid' },
      props.links,
      _react2.default.createElement('hr', null),
      _react2.default.createElement(
        'div',
        { className: 'copyright' },
        '\xA9 All Rights Reserved \xA0\xA0 ',
        props.releaseInfo
      )
    )
  );
};

Footer.propTypes = {
  links: _propTypes2.default.node,
  releaseInfo: _propTypes2.default.string
};

exports.default = Footer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Footer.js
// module id = 443
// module chunks = 0